import { ActionIcon, Box, Group, Table } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';

interface CategoriesListProps {
	categories: any[];
	onEdit: (category: any) => void;
}

export function CategoriesList({ categories, onEdit }: CategoriesListProps) {
	return (
		<Table.ScrollContainer minWidth={500}>
			<Table>
				<Table.Thead>
					<Table.Tr>
						<Table.Th>Name</Table.Th>
						<Table.Th>Color</Table.Th>
						<Table.Th style={{ width: 100 }}>Actions</Table.Th>
					</Table.Tr>
				</Table.Thead>
				<Table.Tbody>
					{categories.map((category) => (
						<Table.Tr key={category.id}>
							<Table.Td>{category.name}</Table.Td>
							<Table.Td>
								<Group gap="xs">
									<Box
										style={{
											width: 20,
											height: 20,
											borderRadius: 4,
											backgroundColor: category.color,
											border: '1px solid #dee2e6',
										}}
									/>
									<span>{category.color}</span>
								</Group>
							</Table.Td>
							<Table.Td>
								<Group gap="xs">
									<ActionIcon variant="subtle" color="#1A4D66" onClick={() => onEdit(category)}>
										<IconEdit size={16} />
									</ActionIcon>
								</Group>
							</Table.Td>
						</Table.Tr>
					))}
				</Table.Tbody>
			</Table>
		</Table.ScrollContainer>
	);
}
